export const COMPANY_SUMMARY_TEST_IDS = {
  atAGlanceTabPanel: 'company-summary__tab-panel-at-a-glance',
  chartCard: (metric: 'unrealized-value' | 'moic' | 'invested-capital') =>
    `company-summary__chart-card-${metric}`,
  chartsGrid: 'company-summary__charts-grid',
  companyOverviewCompanyInfo: 'company-overview__company-information',
  companyOverviewRoot: 'company-overview__root',
  companySummaryTabPanel: 'company-summary__tab-panel-company-summary',
  forbiddenState: 'company-summary__forbidden-state',
  noInvestmentsState: 'company-summary__no-investments-state',
  pinAllChartsButton: 'company-summary__pin-all-charts-button',
  unitsToggleButton: 'company-summary__units-toggle-button',
  companyOverviewTabPanel: 'company-summary__tab-panel-company-overview',
  dailyMonitoringTabPanel: 'company-summary__tab-panel-daily-monitoring',
} as const;
